import React, { Component } from 'react'
import {reduxForm, Field, initialize} from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import InputCheckBox from '../../comun/form/InputCheckBox'
import { Refresh, Delete, Launch, Print, AddCircleOutline } from '@material-ui/icons'
import {permisos as permisosConstant} from '../../../constants/permisos'

class FiltrosTipoIntervencionSanitaria extends Component {
   constructor () {
    super()
    this.state = {
      imputSelected: false,
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.datosExcelTipoIntervencion !== prevProps.datosExcelTipoIntervencion) {
      if (this.props.datosExcelTipoIntervencion.excel && this.props.datosExcelTipoIntervencion.excel !== null){
        let pdf = this.props.datosExcelTipoIntervencion.excel
        let element = document.createElement('a')
        // element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(pdf))
        element.setAttribute('href', 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(pdf))
        element.setAttribute('download', this.props.t('MENU.PLAN_SANITARIO.INTERVENCIONES_SANITARIAS.TIPOS_INTERVENCION') + ".xlsx")
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      }
    }
    if (this.props.datosPdfTipoIntervencion !== prevProps.datosPdfTipoIntervencion) {
      if (this.props.datosPdfTipoIntervencion.pdf && this.props.datosPdfTipoIntervencion.pdf !== null){
        let pdf = this.props.datosPdfTipoIntervencion.pdf
        let element = document.createElement('a')
        element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(pdf))
        element.setAttribute('download', this.props.t('MENU.PLAN_SANITARIO.INTERVENCIONES_SANITARIAS.TIPOS_INTERVENCION') + ".pdf")
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      }
    }
    if (this.props.formSimpleTable && Object.keys(this.props.formSimpleTable).length > 0) {
      if (this.props.formSimpleTable !== prevProps.formSimpleTable) {
        let contActivos = 0
        if (this.props.formSimpleTable.values) {
          Object.values(this.props.formSimpleTable.values).forEach((value) => {
            if (value === true) {
              contActivos++
            }
          })
          if (contActivos === 0) {
            this.props.change('seleccionar-todo', false)
            this.setState({ imputSelected: false })
            this.props.actions.deSeleccionarTodosTipoIntervencionSanitaria()
          }
        }
      }
    }
  }

  intercambiarCheck = (value) => {
    this.setState({ imputSelected: value })
    if (value === true) {
      this.props.actions.seleccionarTodosTipoIntervencionSanitaria()
    } else {
      this.props.actions.deSeleccionarTodosTipoIntervencionSanitaria()
    }
  }

  cambiarEstadoSeleccionTipoIntervencionSanitaria(){
    const itemsSeleccion = this.props.list.map((row) => {
      return this.props.formSimpleTable.values['check' + row.idElemento] === true && (
        {
          'check': this.props.formSimpleTable.values['check' + row.idElemento],
          'idTipoIntervencion': row.idTipoIntervencion
        }
      )
    })

    let list = itemsSeleccion.filter(function (item) {
      return item.check === true;
    });
    this.props.actions.cambiarEstadoSeleccionTipoIntervencionSanitaria(list)
  }

  deleteSeleccionTipoIntervencionSanitaria(){
    const itemsSeleccion = this.props.list.map((row) => {
      return this.props.formSimpleTable.values['check' + row.idElemento] === true && (
        {
          'check': this.props.formSimpleTable.values['check' + row.idElemento],
          'idTipoIntervencion': row.idTipoIntervencion
        }
      )
    })

    let list = itemsSeleccion.filter(function (item) {
      return item.check === true;
    });
    this.props.actions.deleteSeleccionTipoIntervencionSanitaria(list)
  }

  crearCsvTipoIntervencion(){
    this.props.actions.crearCsvTipoIntervencion(this.props.list)
  }

  imprimirPdfTipoIntervencion(){
    this.props.actions.imprimirPdfTipoIntervencion(this.props.list)
  }

  render () {
  const {
    t, handleSubmit,
    actions: {abrirModalVacioTipoIntervencionSanitaria}
  } = this.props

  return (
      <div>
        <Row className="acciones-tabla-filtros">
          <Col sm={12}>
            <div className="buttons-flex">
              {(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.TIPOS_INTERVENCION_SANITARIA] > 1) && [
                <div className="custom-check-w" key="custom-check-w">
                  <Field
                    id="seleccionar-todo"
                    name="seleccionar-todo"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    onInputChange={(value) => this.intercambiarCheck(value)}
                  />
                </div>,
                <div id="block-options" key="block-options" className={this.state.imputSelected === true ? 'button-group buttons-min block-options' : 'button-group buttons-min block-options oculta-action'}>
                  <button type="button" data-toggle="modal" data-target="#cambio-estado" className="btn btn-icono" onClick={(e) => this.cambiarEstadoSeleccionTipoIntervencionSanitaria()}>
                    <Refresh></Refresh> {t('TITULOS_BOTONES.CAMBIAR_ESTADO')}
                  </button>
                  <button type="button" data-toggle="modal" data-target="#delete-modal" className="btn btn-icono" onClick={(e) => this.deleteSeleccionTipoIntervencionSanitaria()}>
                    <Delete></Delete> {t('TITULOS_BOTONES.ELIMINAR')}
                  </button>
                  <div className="barra-buttons-min"></div>
                </div>
              ]}
              <div className="button-group buttons-min">
                <button type="button" className="btn btn-icono" onClick={(e) => this.crearCsvTipoIntervencion()}>
                  <Launch></Launch> {t('TITULOS_BOTONES.EXPORTAR')}
                </button>
                <button type="button" className="btn btn-icono" onClick={(e) => this.imprimirPdfTipoIntervencion()}>
                  <Print></Print> {t('TITULOS_BOTONES.IMPRIMIR')}
                </button>
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#new-edit-modal"
                  className={"btn btn-primary nuevo" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.TIPOS_INTERVENCION_SANITARIA] < 2) ? ' disabled' : '')}
                  onClick={(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.TIPOS_INTERVENCION_SANITARIA] > 1) ? abrirModalVacioTipoIntervencionSanitaria : undefined}
                >
                  <AddCircleOutline></AddCircleOutline> {t('TITULOS_BOTONES.NUEVO')}
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default (reduxForm({
  form: 'filtrosTipoIntervencionSanitaria',
  enableReinitialize: true
})(FiltrosTipoIntervencionSanitaria))
